export const IMPORTSITE_IMPORT = 'IMPORTSITE_IMPORT';
export const IMPORTSITE_ERROR = 'IMPORTSITE_ERROR';
export const IMPORTSITE_CLEAR_ERROR = 'IMPORTSITE_CLEAR_ERROR';
export const IMPORTSITE_CLEAR_DATA = 'IMPORTSITE_CLEAR_DATA';


// WEBPACK FOOTER //
// ./src/pages/importsite/state/types.js